import React from 'react';
import { Alert } from '../Alert';

import { FaDownload } from 'react-icons/fa';

const Candidato = ({
    onDownload,
    situacaoCalendario,
    candidato,
    fl_pendencias,
    vestibular,
    podeMostrarNotificacaoDeProcessamentoDeferimento = false,
    podeMostrarNotificacaoDeProcessamentoIndeferimento = false,
}) => {
    return (
        <div className="row">
            <div className="d-flex col-12">
                <div className="flex-fill w-100 card">
                    <div className="card-header">
                        <h5 className="mb-0 card-title">Dados do Candidato</h5>
                    </div>
                    <div className="card-body">
                        <div className="label-text">
                            <div className="label-text__label">Processo seletivo:</div>
                            <span className="label-text__text">{candidato.ds_vestibular}</span>
                        </div>
                        <div className="label-text">
                            <div className="label-text__label">Chamamento:</div>
                            <span className="label-text__text">{candidato.chamamentoDesc}</span>
                        </div>
                        <div className="label-text">
                            <div className="label-text__label">Nome:</div>
                            <span className="label-text__text">{candidato.nome}</span>
                        </div>
                        {candidato?.curso && (
                            <div className="label-text">
                                <div className="label-text__label">Curso:</div>
                                <span className="label-text__text">{candidato.curso}</span>
                            </div>
                        )}
                        {candidato?.classificacao && (
                            <div className="label-text">
                                <div className="label-text__label">Modalidade de convocação:</div>
                                <span className="label-text__text">{candidato.modalidade}</span>
                            </div>
                        )}
                        {candidato?.nr_matricula && (
                            <>
                                <div className="label-text">
                                    <div className="label-text__label">Matrícula:</div>
                                    <span className="label-text__text">{candidato.nr_matricula}</span>
                                </div>
                                <div className="label-text">
                                    <button type="button" className="btn btn-primary" onClick={() => onDownload()}>
                                        <FaDownload size={14} /> Comprovante de Solicitação de Matrícula
                                    </button>
                                </div>
                                {candidato.informacoes && (
                                    <blockquote className="blockquote-info">
                                        <h2>Informações</h2>
                                        <div dangerouslySetInnerHTML={{ __html: candidato.informacoes }} />
                                    </blockquote>
                                )}
                            </>
                        )}
                    </div>

                    {podeMostrarNotificacaoDeProcessamentoDeferimento &&
                        !candidato?.informacoes &&
                        candidato.chamamento > 0 &&
                        (situacaoCalendario?.status === 'resultado_complementacao' ||
                            situacaoCalendario?.status === 'aberto_recurso' ||
                            situacaoCalendario?.status === 'aguardando_resultado_recurso' ||
                            situacaoCalendario?.status === 'resultado_recurso') && (
                            <Alert variant="success" className="mx-4">
                                <strong>Resultado da Solicitação de Matrícula</strong>
                                <br />
                                Sua documentação foi <strong>DEFERIDA</strong> e sua matrícula está em processamento. O comprovante do de matrícula estará disponível, neste sistema, a partir do dia{' '}
                                <strong>{situacaoCalendario?.resultado_recurso}.</strong>.
                            </Alert>
                        )}

                    {podeMostrarNotificacaoDeProcessamentoIndeferimento &&
                        !candidato?.informacoes &&
                        candidato.chamamento > 0 &&
                        (situacaoCalendario?.status === 'resultado_complementacao' ||
                            situacaoCalendario?.status === 'aberto_recurso' ||
                            situacaoCalendario?.status === 'aguardando_resultado_recurso' ||
                            situacaoCalendario?.status === 'resultado_recurso') && (
                            <Alert variant="danger" className="mx-4">
                                <strong>Resultado da solicitação de matrícula</strong>
                                <br />
                                Sua documentação, enviada para solicitação de matrícula, foi <strong>INDEFERIDA</strong>. Utilize o prazo previsto no Edital para realizar seu recurso. O Recurso
                                deve ser feito exclusivamente neste sistema, através do formulário abaixo.
                            </Alert>
                        )}
                    {fl_pendencias && !candidato.informacoes ? (
                        <div className="card-footer">
                            <Alert variant="warning">
                                <strong>Atenção!</strong> Você ainda não confirmou o envio de todos os documentos.
                            </Alert>
                        </div>
                    ) : candidato.informacoes && !candidato.nr_matricula ? (
                        <div className="card-footer">
                            <Alert variant="danger" icon={false}>
                                <div dangerouslySetInnerHTML={{ __html: candidato.informacoes }} />
                            </Alert>
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    );
};

export default Candidato;
